export default "__VITE_ASSET__00b1decb__"